import { Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf, NgFor } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';

import { UNDERSCORE } from '../../../shared/utils/constant';
import { AqdbBatch } from '../../models/aqdb-batch';
import { pageTransitions } from '../../../shared/animations/page-transitions';
import { LocationService } from '../../../shared/services/location.service';
import { AqdbQualityDataService, QUALITY_DATA_BATCH_FIELD } from '../../services/aqdb-quality-data.service';
import { UserService } from '../../../shared/services/user.service';
import { User } from '../../../shared/models/user';
import { LoadingSpinnerComponent } from '../../../shared/components/utils/loading-spinner.component';
import { BackButtonComponent } from '../../../shared/components/back-button/back-button.component';

import { MetalUnitComponent } from './metal-unit/metal-unit.component';
import { OtherCharacteristicsComponent } from './metal-unit/other-characteristics.component';
import { ShippingCharacteristicsComponent } from './metal-unit/shipping-characteristics.component';
import { MechanicalCharacteristicsComponent } from './mechanical-characteristics/mechanical-characteristics.component';
import { ChemicalCharacteristicsComponent } from './chemical-characteristics/chemical-characteristics.component';
import { MagneticCharacteristicsComponent } from './magnetic-characteristics/magnetic-characteristics.component';
// eslint-disable-next-line @stylistic/max-len
import { CoatingSurfaceCharacteristicsComponent } from './coating-surface-characteristics/coating-surface-characteristics.component';

@Component({
	selector: 'copo-aqdb-batch-card',
	templateUrl: './aqdb-batch-card.component.html',
	styleUrl: './aqdb-batch-card.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		BackButtonComponent,
		TranslateModule,
		MetalUnitComponent,
		OtherCharacteristicsComponent,
		ShippingCharacteristicsComponent,
		NgFor,
		MechanicalCharacteristicsComponent,
		LoadingSpinnerComponent,
		ChemicalCharacteristicsComponent,
		MagneticCharacteristicsComponent,
		CoatingSurfaceCharacteristicsComponent,
		MatIconModule,
		MatTooltipModule,
		MatExpansionModule
	]
})
export class AqdbBatchCardComponent {
	@HostBinding('class.passthrough') readonly passthrough = true;

	batchData!: AqdbBatch;
	user: User;
	qualityDataSub?: Subscription;
	qualityDataBatchId: string;
	readonly UNDERSCORE = UNDERSCORE;
	isLoading = false;
	isValidServiceAvailable = false;

	constructor(
		private readonly route: ActivatedRoute,
		private readonly userService: UserService,
		private readonly aqdbQualityDataService: AqdbQualityDataService,
		private readonly locationService: LocationService,
	) {
		this.isLoading = true;
		this.user = this.userService.user;
		this.qualityDataBatchId = <string> this.route.snapshot.params['batchid'];
		this.isValidServiceAvailable = this.user.hasService('VALID');
		this.qualityDataSub = this.aqdbQualityDataService.getQualityDataBatchById(
			this.qualityDataBatchId,
			QUALITY_DATA_BATCH_FIELD
		)
			.subscribe({
				next: res => {
					this.batchData = res;
					this.isLoading = false;
				},
				error: (error: unknown) => {
					console.error('error loading', error);
				},
				complete: () => {
					this.isLoading = false;
				}
			});
	}

	goBack() {
		this.locationService.go(-1);
	}
}
